import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
// import { markEditSectionAsRead } from 'AppSrc/core/actions/actions-edit-form';
// import ReactRouterPropTypes from 'react-router-prop-types';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { SectionSummary } from 'AppSrc/core/components/forms/form-base-components/summary-components/section-summary';
import { ExpandCollapseAll } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/expand-collapse-all';
import { COMPLETION_REVIEW } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/section-summary.css';


class ViewCrqCloneSectionSummary extends React.Component {
  constructor(props) {
    super(props);
    const openStatuses = this.getInitialOpenStatuses();
    this.state = {
      openStatuses,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.generateOpenStatusesArray = this.generateOpenStatusesArray.bind(this);
    this.getInitialOpenStatuses = this.getInitialOpenStatuses.bind(this);
    // this.navigateToSection = this.navigateToSection.bind(this);
    this.getSectionsToShow = this.getSectionsToShow.bind(this);
  }

  getInitialOpenStatuses() {

    const {
      formData,
      // viewCrqPowers,
    } = this.props;
    // const {
    //   // canViewErrors,
    // } = viewCrqPowers;

    const {
      formSectionsByDisplayOrder,
      summaryErrors,
    } = formData;

    // we don't always show errors
    const hasViewableErrors = true && summaryErrors;

    // if it's cancelled, we don't show errors
    if (!hasViewableErrors) {
      return this.generateOpenStatusesArray(false);
    }

    return formSectionsByDisplayOrder.map((sectionId) => {
      const sectionErrors = summaryErrors[sectionId];
      const hasError = sectionErrors && Object.keys(sectionErrors).length > 0;
      return hasError;
    });
  }

  // get the list of form sections to display
  getSectionsToShow() {
    const { formData } = this.props;
    // remove completion review section
    const formSectionsByDisplayOrder = formData.formSectionsByDisplayOrder.filter((section) => section !== COMPLETION_REVIEW);
    return formSectionsByDisplayOrder;
    // return formData.formSectionsByDisplayOrder;
  }

  // Generate array representing the open status of each section
  // sections[3] is open if openStatuses[3] == true
  // initialised all elements with value of `areOpen`
  generateOpenStatusesArray(areOpen) {
    const numSections = this.getSectionsToShow().length;
    return Array(numSections).fill(areOpen);
  }

  // navigateToSection(options) {
  //   const {
  //     history,
  //     crqId,
  //     network,
  //   } = this.props;
  //   const {
  //     navToSectionId,
  //   } = options;

  //   this.props.markEditSectionAsRead(crqId, navToSectionId);
  //   window.localStorage.setItem('validation', true);
  //   window.localStorage.setItem('validation1', true);
  //   window.localStorage.setItem('validation2', true);

  //   history.push(`/crq/edit/${network}/${crqId}/${navToSectionId}`);
  // }

  expandAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(true),
    });
  }

  collapseAll() {
    this.setState({
      openStatuses: this.generateOpenStatusesArray(false),
    });
  }

  toggleOpen(sectionIndex) {
    // const {
    //   crqId,
    // } = this.props;

    // const sectionIds = this.getSectionsToShow();
    // const sectionId = sectionIds[sectionIndex];
    // this.props.markEditSectionAsRead(crqId, sectionId);

    this.setState((prevState) => {
      // toggle the boolean value of openStatuses[sectionIndex]
      const openStatuses = prevState.openStatuses.map(
        (open, index) => (index === sectionIndex ? !open : open),
      );
      return ({
        openStatuses,
      });
    });
  }

  render() {
    const {
      formData,
      network,
      // summarySectionsRead,
      // viewCrqPowers,
      viewType,
      hasErrors,
      // assign, // adding for graying out the button
      changeAnalystCircuitCheckID, // adding for graying out the button
      userLoggedIn, // adding for graying out the button
      impactValue, // for use in rescheduling
      hasReferenceCRQ,
    } = this.props;
    const {
      dataByFormSectionId,
      summaryErrors,
    } = formData;

    // const {
    //   // canEditForm,
    //   canViewSectionsRead,
    // } = viewCrqPowers;

    const { openStatuses } = this.state;
    const allExpanded = openStatuses.every((open, index) => index === 0 || open);



    // const navigateToSection = canEditForm ? this.navigateToSection : null;
    // disables the submit button if the form is not readyToSubmit... Also does a hack to stop mobile submission!

    // expand all prevents the user from knowing if they have read something so we disable it if
    // the user is expected to read each section
    const initialExpand = false;
    const showExpandAll = !initialExpand;

    return (
      <div className="view-crq-section-summary">
        {
          showExpandAll && (
            <ExpandCollapseAll
              className="expand-collapse-all expand-collapse-all-top"
              allExpanded={allExpanded}
              collapseAll={this.collapseAll}
              expandAll={this.expandAll}
            />
          )
        }
        <div className="sections clone-summary-wrapper">
          {
            this.getSectionsToShow().map((sectionId, index) => {
              const formSection = dataByFormSectionId[sectionId];
              const open = openStatuses[index];

              if (formSection) {
                return (
                  <SectionSummary
                    key={sectionId}
                    open={open}
                    formSection={formSection}
                    sectionIndex={index}
                    toggleOpen={this.toggleOpen}
                    // navigateToSection={navigateToSection}
                    sectionErrors={hasErrors ? summaryErrors[sectionId] : null}
                    // summarySectionRead={summarySectionsRead[sectionId]}
                    viewType={viewType}
                    hasErrors={hasErrors}
                    selectedNetwork={network}
                    formData={formData}
                    // assign={assign}
                    changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
                    userLoggedIn={userLoggedIn}
                    impactValue={impactValue} // sending for rescheduling changes
                    network={network} // sending for rescheduling changes
                    hasReferenceCRQ={hasReferenceCRQ}
                  />
                );
              }
              return null;
            })
          }
        </div>
        {
          showExpandAll && (
            <ExpandCollapseAll
              className="expand-collapse-all expand-collapse-all-bottom"
              allExpanded={allExpanded}
              collapseAll={this.collapseAll}
              expandAll={this.expandAll}
            />
          )
        }
      </div>
    );
  }
}

ViewCrqCloneSectionSummary.propTypes = {
  // crqId: PropTypes.string,
  network: PropTypes.string,
  formData: formDataShape,
  // history: ReactRouterPropTypes.history,
  // summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  // markEditSectionAsRead: PropTypes.func,
  // viewCrqPowers: PropTypes.objectOf(PropTypes.bool),
  viewType: PropTypes.string,
  hasErrors: PropTypes.bool,
  // assign: PropTypes.bool,
  userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  impactValue: PropTypes.string,
  hasReferenceCRQ: PropTypes.bool,
};

// const mapStateToProps = (state, ownProps) => {
//   const formData = state.editForm.formDataById[ownProps.crqId];
//   // const { coordinatorId, peerReviewerId } = formData;
//   // const { refreshingPou } = state.pou;
//   console.log('clone summary props', formData, ownProps.crqId);
//   return ({
//     formData,
//     // peerReviewerId,
//     // refreshingPou,
//   });
// };

// const mapDispatchToProps = (dispatch, ownProps) => ({
//   markEditSectionAsRead: (crqId, sectionId) => {
//     const {
//       viewCrqPowers,
//     } = ownProps;

//     // we only want this to fire if the user can view sections read
//     const {
//       canViewSectionsRead,
//     } = viewCrqPowers;

//     if (canViewSectionsRead) {
//       dispatch(markEditSectionAsRead(crqId, sectionId));
//     }
//     return null;
//   },
// });

ViewCrqCloneSectionSummary = connect(
  // mapStateToProps,
  null,
)(ViewCrqCloneSectionSummary);


const CloneSummary = ({ crqId }) => {
  const formData = useSelector((state) => state.editForm.formDataById[crqId]);
  return (
    <>
      {formData && (
        <ViewCrqCloneSectionSummary
          formData={formData}
          // network={network}
          // remedyId={remedyId}
          crqId={crqId}
        // history={history}
        // summarySectionsRead={summarySectionsRead}
        // viewCrqPowers={viewCrqPowers}
        // viewType={viewType}
        // hasErrors={hasErrors}
        // changeAnalystCircuitCheckID={changeAnalystCircuitCheckID}
        // userLoggedIn={userLoggedIn}
        // impactValue={impactValue} // sending for rescheduling page
        // hasReferenceCRQ={hasReferenceCRQ}
        />
      )}
    </>
  );
};

CloneSummary.propTypes = {
  crqId: PropTypes.string,
  // network: PropTypes.string,
  // formData: formDataShape,
  // history: ReactRouterPropTypes.history,
  // summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  // markEditSectionAsRead: PropTypes.func,
  // viewCrqPowers: PropTypes.objectOf(PropTypes.bool),
  // viewType: PropTypes.string,
  // hasErrors: PropTypes.bool,
  // // assign: PropTypes.bool,
  // userLoggedIn: PropTypes.string,
  // changeAnalystCircuitCheckID: PropTypes.string,
  // impactValue: PropTypes.string,
  // hasReferenceCRQ: PropTypes.bool,
};
// const mapStateToProps = (state, ownProps) => {
//   const formData = state.editForm.formDataById[ownProps.crqId];
//   // const { coordinatorId, peerReviewerId } = formData;
//   // const { refreshingPou } = state.pou;
//   console.log('clone summary props', formData, ownProps.crqId);
//   return ({
//     formData,
//     // peerReviewerId,
//     // refreshingPou,
//   });
// };

// const CloneSummary = connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(CloneSummaryConnected);


export {
  ViewCrqCloneSectionSummary,
  CloneSummary,
};



